(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/init.js');

'use strict';

svs.matchen.tipsInfo = new svs.matchen.models.TipsInfo();
svs.matchen.app.config = new svs.matchen.models.Config();
svs.matchen.app.start();


 })(window);